import { Link } from "react-router-dom";
import { X } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-24 text-center">
      <div className="mx-auto w-16 h-16 border border-zinc-800 flex items-center justify-center mb-6">
        <X size={36} className="text-zinc-500" />
      </div>
      <div className="text-xs font-mono-alt uppercase text-zinc-500 tracking-widest mb-2">Payment canceled</div>
      <h1 className="font-display text-5xl uppercase leading-none">No charge <span className="text-yellow-500">made</span></h1>
      <p className="text-zinc-400 mt-4">Your job draft is saved. You can resume the checkout anytime.</p>
      <div className="mt-8">
        <Link to="/post-job" className="bg-yellow-500 text-black font-bold uppercase tracking-wider px-6 py-3 hover:bg-yellow-400 transition">Try Again</Link>
      </div>
    </div>
  );
}
